export enum EClasseBPPH {
    BPPH =  12
}